import { all } from "redux-saga/effects";

//public
import accountSaga from "./auth/register/saga";
import loginSaga from "./auth/login/saga";
import forgetSaga from "./auth/forgetpwd/saga";
import LayoutSaga from "./layout/saga";
import usersSaga from "./CompanySettings/users/saga";
import ProfileSaga from "./CompanySettings/Profiles/saga";
import menuSaga from "./menu/saga";

//VendorQuotation
import VendorQuotationSaga from "./VendorQuotation/saga";
import VendorPOSaga from "./VendorPO/saga";

import miniSaga from "./Mini/saga";

import userProfileSaga from "./UserProfile/saga";

import MenuSaga from "./Masters/Menus/saga";
import MenuItemSaga from "./Masters/MenuItems/saga";
import MastersMenuSaga from "./Masters/MastersMenu/saga";
import LocationSaga from "./Masters/Locations/saga";
import QualitySaga from "./Masters/quality/saga";
import SubLocationSaga from "./Masters/SubLocations/saga";
import ORDERLOCATIONSSaga from "./Masters/OrderLocations/saga";
import DepartmentSaga from "./Masters/Departments/saga";
import ProductGroupSaga from "./Masters/ProductGroups/saga";
import ProductSaga from "./Masters/Products/saga";
import VendorSaga from "./Masters/Vendors/saga";
import CategorySaga from "./Masters/Category/saga";
import SectionSaga from "./Masters/Section/saga";
import BasicUnitSaga from "./Masters/BasicUnit/saga";
import TaxSaga from "./Masters/Taxs/saga";
import PrefixCodeSaga from "./Masters/PrefixCode/saga";

import MaterialRequestSaga from "./MaterialRequest/saga";
import ServiceRequestSaga from "./ServiceRequest/saga";
import PurchaseIndentSaga from "./PurchaseIndent/saga";
import SRPurchaseIndentSaga from "./SRPurchaseIndent/saga";
import RequestForQuotationSaga from "./RequetForQuotation/saga";
import SRRequestForQuotationSaga from "./SRRequetForQuotation/saga";
import QuotationSaga from "./Quotation/saga";
import SRQuotationSaga from "./SRQuotation/saga";
import CompareQuotationSaga from "./CompareQuotation/saga";
import SRCompareQuotationSaga from "./SRCompareQuotation/saga";
import PurchaseOrderSaga from "./PurchaseOrder/saga";
import SRPurchaseOrderSaga from "./SRPurchaseOrder/saga";
import ingatepassSaga from "./ingatepass/saga";
import DashboardSaga from "./Dashboard/saga";
import NotificationSaga from "./Notification/saga";
import SystemSaga from "./System/saga";

import reportsSaga from "./Reports/saga";

import AuditReportSaga from "./Audit_Report/saga";

export default function* rootSaga() {
	yield all([
		//public
		accountSaga(),
		loginSaga(),
		forgetSaga(),
		LayoutSaga(),
		usersSaga(),
		ProfileSaga(),
		menuSaga(),

		//VendorQuotation
		VendorQuotationSaga(),
		VendorPOSaga(),

		miniSaga(),
		//User Profile
		userProfileSaga(),

		MenuSaga(),
		MenuItemSaga(),
		MastersMenuSaga(),
		LocationSaga(),
		QualitySaga(),
		SubLocationSaga(),
		ORDERLOCATIONSSaga(),
		DepartmentSaga(),
		ProductGroupSaga(),
		ProductSaga(),
		VendorSaga(),
		CategorySaga(),
		SectionSaga(),
		BasicUnitSaga(),
		TaxSaga(),
		PrefixCodeSaga(),

		MaterialRequestSaga(),
		ServiceRequestSaga(),
		PurchaseIndentSaga(),
		SRPurchaseIndentSaga(),
		RequestForQuotationSaga(),
		QuotationSaga(),
		CompareQuotationSaga(),
		SRCompareQuotationSaga(),
		PurchaseOrderSaga(),
		SRPurchaseOrderSaga(),
		ingatepassSaga(),
		DashboardSaga(),
		NotificationSaga(),
		SRRequestForQuotationSaga(),
		SystemSaga(),
		SRQuotationSaga(),
		reportsSaga(),

		AuditReportSaga(),
	]);
}
